import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { About } from '../components/About';
import { Activities } from '../components/Activities';
import { News } from '../components/News';
import { Membership } from '../components/Membership';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-neutral-light" data-id="element-785">
      <Header data-id="element-786" />
      <main data-id="element-787">
        <Hero data-id="element-788" />
        <Stats data-id="element-789" />
        <About data-id="element-790" />
        <Activities data-id="element-791" />
        <News preview data-id="element-792" />
        <Membership data-id="element-793" />
      </main>
      <Footer data-id="element-794" />
    </div>;
}